var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoFound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 190,
    viewBox: "0 0 190 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_12947_434288)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 15,
    width: 150,
    height: 150,
    rx: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.9497,
    y: 34.5547,
    width: 106.527,
    height: 81.1406,
    rx: 4,
    stroke: "#16BAE7",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3918 108.13C55.3157 107.254 54.1132 107.887 53.6465 108.312C50.4632 111.404 43.7488 117.892 42.3574 119.111C40.9659 120.329 41.2888 121.528 41.6241 121.976C42.4079 122.788 44.2444 124.631 45.3206 125.508C46.3967 126.384 47.57 125.945 48.0222 125.617L59.6941 114.281C60.543 113.457 60.4491 112.609 60.296 112.289C59.6107 111.491 57.468 109.007 56.3918 108.13Z",
    fill: "#00233A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 38.5C50 36.2909 51.7909 34.5 54 34.5H152C154.209 34.5 156 36.2909 156 38.5V44.5H50V38.5Z",
    stroke: "#16BAE7",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2822 117.64C42.6929 116.329 40.9118 117.281 40.2199 117.922C35.5002 122.571 25.5452 132.329 23.4826 134.162C21.4201 135.996 21.8938 137.794 22.3885 138.464C23.5455 139.681 26.2566 142.441 27.8459 143.752C29.4352 145.063 31.1725 144.402 31.8425 143.907L49.1479 126.859C50.4065 125.619 50.2702 124.348 50.0448 123.867C49.0335 122.673 45.8715 118.951 44.2822 117.64Z",
    fill: "#16BAE7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.6747,
    cy: 96.5981,
    r: 27.3842,
    transform: "rotate(8.55885 70.6747 96.5981)",
    fill: "#00233A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.6745,
    cy: 96.5989,
    r: 18.5506,
    transform: "rotate(8.55885 70.6745 96.5989)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.767,
    cy: 37.4835,
    r: 1.76672,
    fill: "#00233A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.5884,
    y: 60.5,
    width: 51.235,
    height: 1.76672,
    transform: "rotate(0.635041 54.5884 60.5)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.5884,
    y: 50.4062,
    width: 51.235,
    height: 1.76672,
    transform: "rotate(0.635041 54.5884 50.4062)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.5884,
    y: 55.6465,
    width: 51.235,
    height: 1.76672,
    transform: "rotate(0.635041 54.5884 55.6465)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.5 105.645C123.844 105.645 123.219 105.522 122.624 105.276C122.029 105.03 121.487 104.682 120.997 104.232L101.269 84.5034C100.818 84.0117 100.47 83.4684 100.224 82.8735C99.9779 82.2786 99.855 81.6542 99.855 81.0003C99.855 80.3447 99.9779 79.7097 100.224 79.0951C100.47 78.4805 100.818 77.9478 101.269 77.4972L120.997 57.769C121.488 57.2774 122.032 56.9184 122.627 56.6923C123.221 56.4661 123.846 56.3538 124.5 56.3555C125.155 56.3555 125.79 56.4686 126.405 56.6947C127.02 56.9209 127.552 57.279 128.003 57.769L147.731 77.4972C148.223 77.9478 148.582 78.4805 148.808 79.0951C149.034 79.7097 149.146 80.3447 149.145 81.0003C149.145 81.6558 149.032 82.2811 148.808 82.876C148.583 83.4709 148.224 84.0134 147.731 84.5034L128.003 104.232C127.552 104.682 127.02 105.03 126.405 105.276C125.79 105.522 125.155 105.645 124.5 105.645ZM122.041 83.4586H126.958V68.7086H122.041V83.4586ZM124.5 90.8336C125.196 90.8336 125.781 90.5976 126.253 90.1256C126.725 89.6536 126.96 89.0702 126.958 88.3753C126.958 87.6787 126.722 87.0945 126.25 86.6225C125.778 86.1505 125.195 85.9153 124.5 85.9169C123.803 85.9169 123.219 86.1529 122.747 86.6249C122.275 87.0969 122.04 87.6804 122.041 88.3753C122.041 89.0718 122.277 89.6561 122.749 90.1281C123.221 90.6001 123.805 90.8353 124.5 90.8336Z",
    fill: "#16BAE7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_12947_434288",
    x: 0,
    y: 0,
    width: 190,
    height: 190,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12947_434288"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12947_434288",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoFound);
export default __webpack_public_path__ + "static/media/noFound.71be9c430dd4139e9e698a3499c261f0.svg";
export { ForwardRef as ReactComponent };